<template>
	<div>
		<case-form :schema="schema" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"

export default {
	components: {
		CaseForm
	},

	computed: {
		schema() {
			return [
				{
					label: `List any medications (prescription or non-prescription) you are currently taking.`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0medicationsCurrentlyTaking`,
					props: {
						suggest: {
							typeIncludes: `medicationsCurrentlyTaking`
						},
						createOptions: {
							type: `medicationsCurrentlyTaking`,
							dataType: "string"
						}
					}
				},
				{
					label: "Height in centimeters",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0heightInCentimeters`,
					props: {
						suggest: {
							typeIncludes: `heightInCentimeters`
						},
						createOptions: {
							type: `heightInCentimeters`,
							dataType: "string"
						}
					}
				},
				{
					label: "Weight in kilograms",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0weightInKilograms`,
					props: {
						suggest: {
							typeIncludes: `weightInKilograms`
						},
						createOptions: {
							type: `weightInKilograms`,
							dataType: "string"
						}
					}
				},
				{
					label: "Has gained weight in past year?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasGainedWeightInPastYear`,
					props: {
						suggest: {
							typeIncludes: `hasGainedWeightInPastYear`
						},
						createOptions: {
							type: `hasGainedWeightInPastYear`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Has loss weight in past year?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasLossWeightInPastYear`,
					props: {
						suggest: {
							typeIncludes: `hasLossWeightInPastYear`
						},
						createOptions: {
							type: `hasLossWeightInPastYear`,
							dataType: "boolean"
						}
					}
				},
				{
					label:
						"If yes, provide details including amount and reason for change",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0weightChangeReason`,
					props: {
						suggest: {
							typeIncludes: `weightChangeReason`
						},
						createOptions: {
							type: `weightChangeReason`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
